import React from 'react';

import Overview from './Overview/Overview';
import OverviewInformation from './OverviewInformation/OverviewInformation';

import './OverviewSection.scss';

export default function OverviewSection(): JSX.Element {
  return (
    <div className="OverviewSection">
      <div className="total-container">
        <h2 className="title">
          <span>Overview</span>
          <p className="note pdf-exclude">
            Clicking on the commodity will automatically redirect you to its section in the report
          </p>
        </h2>
        <div>
          <Overview />
          <OverviewInformation />
        </div>
      </div>
    </div>
  );
}
